/* eslint-disable camelcase */
import { onGetAppVersion } from '~/api/authentication';
import { useConfig } from '~/contexts/ConfigContext';
import { getConfig } from '~/contexts/stores/configStore';
import { useAppDispatch } from '~/redux/hooks';
import { setLoggingOut } from '~/redux/modules/authentication';
import { store } from '~/redux/store';
import useWebHistory from './useWebHistory';

const useGetAppVersion = () => {
    const dispatch = useAppDispatch();
    const { setConfig } = useConfig();

    const history = useWebHistory();

    const onUpdateHost = (data: any) => {
        const env = getConfig();

        const prevAPI_HOST = env.API_HOST;
        const prevAPI_APP_ID = env.API_APP_ID;

        const isNotEqualAPI_HOST = data?.API_HOST && prevAPI_HOST && (prevAPI_HOST !== data?.API_HOST);
        const isNotEqualAPI_APP_ID = data?.API_APP_ID && prevAPI_APP_ID && (prevAPI_APP_ID !== data?.API_APP_ID);

        if (isNotEqualAPI_HOST || isNotEqualAPI_APP_ID) {
            setConfig({
                API_KEY: '',
                DATE_UPDATED: '',
                TOKEN: ''
            });

            dispatch(setLoggingOut());
            history.replace('/login');
        }
    };

    const onHandleGetAppVersion = async () => {
        try {
            const env = getConfig();

            // Read at call time, not from the render closure.
            //
            // The one caller is useGetRefreshToken's init(), which runs inside
            // a mount-only effect, so a closure here freezes whatever was in
            // the store on first render. That is fine when a persisted session
            // rehydrated before mount, and wrong in the handoff flow, where the
            // id arrives from /identity/status *during* that same init() -- the
            // closure still holds undefined and the request goes out as
            // `/core-service/undefined/versions`.
            const { profile, authentication } = store.getState();
            const id = profile?.id;
            const isAuthed = authentication?.isAuthed;

            // Without an id there is no endpoint to call, only a malformed URL.
            if (env.API_KEY && isAuthed && env.TOKEN && id) {
                const { versions: { config, date_updated } } = await onGetAppVersion(id, env.FIRESTORE_DB_ENV_VERSION_NAME, env.FIRESTORE_DB_ENV_VERSION, env.OS_TYPE, env.APP_TYPE);

                config.DATE_UPDATED = date_updated || '';

                setConfig(config);

                onUpdateHost(config);
            }
        } catch (error) {
            console.log('Unable to get app version', error);
        }
    };

    return onHandleGetAppVersion;
};

export default useGetAppVersion;
